import type { AppLocale } from './locales';

export type CommonI18n = {
  errorEyebrow: string;
  errorTitle: string;
  errorMessage: string;
  tryAgain: string;
  backToHome: string;
  publication: string;
  notFoundTitle: string;
  notFoundMessage: string;
  skipToContent: string;
  languageSwitcher: string;
  breadcrumb: string;
  whatsapp: string;
  whatsappGreeting: string;
  mainNavigation: string;
  footerNavigation: string;
  mobileNavigation: string;
  openMenu: string;
  closeMenu: string;
  carouselPrevious: string;
  carouselNext: string;
  slideOf: string;
  starsAriaLabel: (rating: number) => string;
  cookies: {
    message: string;
    accept: string;
    decline: string;
  };
};

export const COMMON_I18N: Record<AppLocale, CommonI18n> = {
  pt: {
    errorEyebrow: 'Erro',
    errorTitle: 'Algo correu mal',
    errorMessage:
      'Ocorreu um erro inesperado. Por favor, tente novamente ou volte à página inicial.',
    tryAgain: 'Tentar novamente',
    backToHome: 'Voltar ao início',
    publication: 'Publicação',
    notFoundTitle: 'Página não encontrada',
    notFoundMessage: 'A página que procura não existe ou foi removida.',
    skipToContent: 'Ir para o conteúdo',
    languageSwitcher: 'Seletor de idioma',
    breadcrumb: 'Trilha de navegação',
    whatsapp: 'Contactar via WhatsApp',
    whatsappGreeting: 'Olá! Gostaria de saber mais.',
    mainNavigation: 'Navegação principal',
    footerNavigation: 'Navegação do rodapé',
    mobileNavigation: 'Navegação móvel',
    openMenu: 'Abrir menu',
    closeMenu: 'Fechar menu',
    carouselPrevious: 'Anterior',
    carouselNext: 'Próximo',
    slideOf: 'de',
    starsAriaLabel: (r) => `${r} de 5 estrelas`,
    cookies: {
      message:
        'Utilizamos cookies analíticos e de publicidade para melhorar a sua experiência. Pode aceitar ou recusar o seu uso.',
      accept: 'Aceitar',
      decline: 'Recusar',
    },
  },
  en: {
    errorEyebrow: 'Error',
    errorTitle: 'Something went wrong',
    errorMessage:
      'An unexpected error occurred. Please try again or return to the home page.',
    tryAgain: 'Try again',
    backToHome: 'Back to home',
    publication: 'Publication',
    notFoundTitle: 'Page not found',
    notFoundMessage:
      'The page you are looking for does not exist or has been removed.',
    skipToContent: 'Skip to content',
    languageSwitcher: 'Language switcher',
    breadcrumb: 'Breadcrumb',
    whatsapp: 'Contact via WhatsApp',
    whatsappGreeting: 'Hello! I would like to know more.',
    mainNavigation: 'Main navigation',
    footerNavigation: 'Footer navigation',
    mobileNavigation: 'Mobile navigation',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
    carouselPrevious: 'Previous',
    carouselNext: 'Next',
    slideOf: 'of',
    starsAriaLabel: (r) => `${r} out of 5 stars`,
    cookies: {
      message:
        'We use analytics and advertising cookies to improve your experience. You can accept or decline their use.',
      accept: 'Accept',
      decline: 'Decline',
    },
  },
};
